import { formatValidationErrors, isValidationErrorStatus } from '../utilities';

const CREATE = 'create';
const EDIT = 'edit';

export default {
    data() {
        return {
            validationErrors: {},
            errorStatusCode: null,
            errorMessage: '',
            pending: false,
            success: false,
            CREATE: CREATE,
            EDIT: EDIT,
            buttonText: this.mode === CREATE ? 'Create' : 'Update'
        }
    },
    methods: {
        handleError(error) {
            if (isValidationErrorStatus(error)) {
                this.validationErrors = formatValidationErrors(error.data.errors);
                this.errorStatusCode = 422;

                this.errorMessage = 'There was a problem with your submission. Errors have been outlined in red.';
            } else {
                if (error.status) {
                    this.errorStatusCode = error.status;
                } else {
                    this.errorStatusCode = 500;
                }

                if (error.data && error.data.message) {
                    this.errorMessage = error.data.message;
                } else {
                    this.errorMessage = 'There was a problem with your submission. Please refresh the page and try again.';
                }
            }
        }
    }
}
